import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../app-settings";
import { HttpClientService } from "../Services/http-client.service";
import { CustomerIoService } from "./customer-io.service";
import { RudderStackService } from "./rudderstack.service";

@Injectable()
export class UserService {
  constructor(
    private httpClientService: HttpClientService,
    private customerIoService: CustomerIoService,
    private rudderStackService: RudderStackService,
  ) {}
  firstName: string;
  email: string;
  scoreKey800: string;
  logout() {
    let headers = new HttpHeaders();
    // analytics.ready(function() {
    //   analytics.reset();
    //   console.log('analytics reset done');
    // });
    // Clear Customer.io identity on logout to prevent identity bleed on shared devices.
    this.customerIoService.reset();
    this.rudderStackService.reset();
    // Ends an admin "Login as User" session, so the next real login on this
    // browser is tracked again. No-op for an ordinary student logout.
    this.rudderStackService.endImpersonatedSession();
    this.httpClientService
      .get(AppSettings.restApiUrl + "/api/logout", headers)
      .subscribe((data) => {
        window.location.href = AppSettings.publicSiteURL;
      });
  }
}
